import { render, staticRenderFns } from "./BaseSvgIcon.vue?vue&type=template&id=4848f660&"
import script from "./BaseSvgIcon.vue?vue&type=script&lang=ts&"
export * from "./BaseSvgIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports